import {ResolveFn} from "@angular/router";
import {inject} from "@angular/core";
import {MatchingVccService} from "../service/matching-vcc.service";
import {firstValueFrom} from "rxjs";

export const matchingVccPaymentDetailReportResolver: ResolveFn<Promise<any>> = (route, _state) => {
  const matchingVccService = inject(MatchingVccService);

  const id = route.paramMap.get('id');
  const fmsBookingId = route.queryParamMap.get('FmsBookingId');

  const data = firstValueFrom(matchingVccService.getMatchingDetails(id ?? '', Number(fmsBookingId ?? 0)));
  return Promise.all([data]);
};
